var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23 23"}},_vm.$listeners),[_c('path',{attrs:{"d":"m6.056 2.539 8.962 8.961-8.962 8.961 1.963 1.963L18.944 11.5 8.019.576 6.056 2.539z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }